import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const ReactContextProvider = (props) => {
    return _jsx(_Fragment, { children: props.children });
};
export default ReactContextProvider;
